export const year2022 = [
  { year: 2022 },
  {
    name: 'Remix Fundamentals',
    author: 'Kent C. Dodds',
    type: 'Course',
    link: 'https://frontendmasters.com/courses/remix/',
    repo: 'https://github.com/andreidobrinski/remix-fundamentals-fm-course',
  },
  {
    name: '100 Days of SwiftUI',
    author: 'Paul Hudson',
    type: 'Course',
    repo: 'https://github.com/andreidobrinski/100-days-of-swiftui-course',
    link: 'https://www.hackingwithswift.com/100/swiftui',
  },
  {
    name: 'Creative Coding with Canvas & WebGL',
    author: 'Matt DesLauriers',
    type: 'Course',
    repo: 'https://github.com/andreidobrinski/canvas-webgl-fm-course',
    link: 'https://frontendmasters.com/courses/canvas-webgl/',
  },
  {
    name: 'Testing JavaScript',
    author: 'Kent C. Dodds',
    type: 'Course',
    link: 'https://testingjavascript.com/',
    repo: 'https://github.com/andreidobrinski/testing-js-course-kcd',
  },
  {
    name: 'Your First iOS & SwiftUI App: An App from Scratch',
    author: 'Ray Wenderlich',
    type: 'Course',
    link: 'https://www.raywenderlich.com/28797163-your-first-ios-swiftui-app-an-app-from-scratch',
    repo: 'https://github.com/andreidobrinski/first-ios-swiftui-course-raywenderlich'
  },
  {
    name: 'Cross Browser Extensions with the web extensions API',
    author: 'Nicole C.',
    type: 'Workshop',
    link: 'https://www.meetup.com/torontojs/events/282839492/',
    repo: 'https://github.com/andreidobrinski/webextension_workshop'
  },
];
